import { SLOTS_APIS } from "@/api_framework/api_config";
import { IBookingCommentsCouponResponse } from "@/api_framework/api_modals/Bookings";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setDiscountCouponData } from "@/app_redux/reducers/slices/auth/slots_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

interface IDiscountCouponQueryParams {
  user_id?: string;
  pet_id?: string;
  sub_service_id?: string;
  clinic_id?: string;
}

export const useBookingDiscountCouponListAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();

  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async (params: IDiscountCouponQueryParams) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      return await axios
        .get(SLOTS_APIS?.COUPONS_LIST?.baseURL ?? "", {
          params,
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IBookingCommentsCouponResponse>) => {
          if (res.data.status === true) {
            dispatch(
              setDiscountCouponData({
                data: res.data.data,
              }),
            );
          } 
        })
        .catch((e: AxiosError) => {
          captureError(e);
          sendCurl(e.config["curlCommand"]);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
